<template>
    <div data-table-vue>
        <input type="text" v-model="filterKey">

        <div id="table--search--data" class="table-responsive">
            <table class="table w-auto table-striped table-bordered table-responsive">
                <thead>
                <tr>
                    <th v-for="key in columns"
                        @click="sortBy(key)"
                        :class="{ active: sortKey === key }">
                        {{ key }}
                        <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
          </span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="entry in filteredDataOrig">
                    <td v-for="key in columns">
                        {{entry[key]}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    // add imports here

    //ADD JSDOC HERE!!!!!
    export default {
        props: ['content'],
        created() {
        },
        destroyed() {
        },
        mounted() {
            this.url = this.content.url;
            this.readRecords();
        },
        data() {
            return {
                url: '',
                inputSearch: '',
                tableContent: {},
                columns: [
                    'name', 'first_name', 'email'
                ],
                data: Array,
                filterKey: '',
                sortKey: String,
                sortOrders: Array
            }
        },
        methods: {
            readRecords() {
                let _this = this;
                axios.post(_this.url, {})
                    .then(function (response) {
                        // console.log('response',response.data);
                        if (response.data.success) {
                            // console.log('response.data',response.data);
                            _this.tableContent = response.data.content;
                            _this.columns = response.data.fields;
                            _this.columns.forEach(function (key) {
                                _this.sortOrders[key] = 1
                            });
                        } else {
                            console.log('nope');
                        }
                    });
            },


            sortBy: function (key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
            }
        },
        filters: {
            capitalize: function (str) {
                return str;
            }
        },
        computed: {
            filteredDataOrig: function () {
                let sortKey = this.sortKey;
                let filterKey = this.filterKey && this.filterKey.toLowerCase();
                if (filterKey.length < 3){
                    return this.tableContent;
                }
                let order = this.sortOrders[sortKey] || 1;
                let data = this.tableContent;
                let limit = 20;
                if (filterKey) {
                    data = data.filter(function (row) {
                        if (limit<=0){
                            return false;
                        }
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
                        })
                    })
                }else{
                    data =  data.slice(0,20);
                    // return;
                }
                // if (sortKey) {
                //     data = data.slice().sort(function (a, b) {
                //         a = a[sortKey];
                //         b = b[sortKey];
                //         return (a === b ? 0 : a > b ? 1 : -1) * order
                //     })
                // }
                // console.log('data',data, data.length);
                return data;
            },
            filteredData() {
                let tableContent = this.tableContent,
                    searchString = this.inputSearch;


                if (!searchString) {
                    return tableContent;
                }

                searchString = searchString.trim().toLowerCase();

                tableContent = this.tableContent.filter(function (item) {

                    for (let i = 0; i < this.fields.length; ++i) {
                        if (item[this.fields[i]].toLowerCase().indexOf(searchString) !== -1) {
                            return item;
                        }
                    }


                })
                return tableContent;

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/tables/table.vue?43c22a8d